/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const clubCommission: CommunityData = {
  code: "clubcommission",
  inviteCode: "clubcommission",
  name: "Clubcommission",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/cco-030`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      counterColor: "",
      logo: {
        src: "https://media.werz.at/community/icon/cmosjb9h200009k3g5his4765.jpg?uploadTime=1777981037193&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: "",
        styles: "",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "",
      asideBg: "",
      asideStyles: "",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      nonMemberBg: "",
      mainFont: "",
      primaryButton: "",
    },
    navigation: {
      iconsColor: "",
      sideBarSeparator: "",
      separator: "",
      item: "",
      itemSelected: "",
    },
    communityLanding: {
      container: "",
      titles: "",
      emptyOrLoadingState: "",
      announcementsV2: {
        sectionContainer: "",
        sectionTitle: "",
        scrollMenu: {
          container: "",
          wrapper: "",
          item: "",
        },
        item: {
          container: "",
          mediaContainer: "",
          media: "",
          placeholderMedia: "",
          content: "",
          title: "",
          subtitle: "",
        },
      },
      eventsV2: {
        sectionContainer: "",
        sectionTitle: "",
        scrollMenu: {
          container: "",
          wrapper: "",
          item: "",
        },
        item: {
          container: "",
          mediaContainer: "",
          media: "",
          placeholderMedia: "",
          content: "",
          title: "",
          subtitle: "",
          location: "",
          date: "",
        },
      },
      shop: {
        container: "",
        title: "",
        text: "",
        customShopImageStyle: "",
        sectionTitle: "",
      },
    },
    comingSoon: {
      bgColor: "",
      hero: {
        desktop: "",
        mobile: "",
        style: "",
      },
      logo: {
        desktop: "",
        mobile: "",
        style: "",
      },
      werzLogoColor: "",
      title: "",
      text: "",
      button: "",
      input: {
        base: "",
        border: "",
        borderFocus: "",
        borderError: "",
        errorText: "",
      },
      error: "",
      footerText: "",
      skipButton: "",
      modal: {
        container: "",
        title: "",
        text: "",
        width: "",
        backdrop: "",
        otpInput: "",
        otpBorder: "",
        otpBorderFocus: "",
      },
    },
    linktree: {
      bgDesktop: "",
      bgMobile:
        "https://media.werz.at/community-assets/clubcomission/mobile-landing-background.mp4?type=video",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#000000]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#444444]",
        name: "text-[#ffffff] font-['HelveticaNeueMedium'] text-[26px] leading-[28.6px] text-center text-center mt-4 mb-1",
        location:
          "font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[16px] leading-[19.2px] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#ffffff",
        button:
          "bg-[#000000] border border-[#000000] px-[16px] py-[12px] text-[#ffffff] text-[14px] text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#444444] text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[16px] leading-[19.2px] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#ffffff] border border-[#444444]",
          title:
            "font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-left text-center mb-1",
          text: "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[16px] leading-[19.2px] text-center text-center",
          button:
            "bg-[#000000] border border-[#000000] px-[16px] py-[12px] text-[#ffffff] text-[14px] text-left w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#444444]",
          duration:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#bdbdbd] font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#ffffff",
          media: "overflow-hidden m-2 border border-[#444444]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#ffffff] border border-[#444444]",
          name: "text-[#bdbdbd] font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#ffffff] border border-[#444444] text-[#000000] font-['HelveticaNeueMedium'] text-[16px] leading-[17.6px] text-center",
          duration:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          location:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#000000] border border-[#000000] px-[16px] py-[12px] text-[#ffffff] text-[14px] text-left w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#444444]",
            name: "text-[#bdbdbd] font-['HelveticaNeueMedium'] leading-[17.6px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#bdbdbd] font-['HelveticaNeueMedium'] leading-[17.6px] text-[14px] text-left",
            link: "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[14px] leading-[16.8px] text-left",
            status:
              "text-[#bdbdbd] font-['HelveticaNeueMedium'] leading-[17.6px] text-[14px] text-left",
            button:
              "bg-[#000000] border border-[#000000] px-[16px] py-[12px] text-[#ffffff] text-[14px] text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[16px] leading-[19.2px] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#444444] text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[16px] leading-[19.2px] text-center",
        header:
          "text-[#ffffff] font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#444444]",
          name: "text-[#bdbdbd] font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#ffffff",
          created:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#444444]",
        },
        seeAllNews:
          "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[16px] leading-[19.2px] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#444444] text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[16px] leading-[19.2px] text-center",
        header:
          "text-[#ffffff] font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#444444]",
          coverUrl: "overflow-hidden m-2 border border-[#444444]",
          duration:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          liveType:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#ffffff] rounded-full",
          playIconColor: "#ffffff",
          start:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#bdbdbd] font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[16px] leading-[19.2px] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#444444] text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[16px] leading-[19.2px] text-center",
        header:
          "text-[#ffffff] font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#444444]",
          name: "text-[#bdbdbd] font-['HelveticaNeueMedium'] leading-[19.8px] text-[16px] text-left",
          triangleIconColor: "#ffffff",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#444444]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#bdbdbd] font-['HelveticaNeueRegular'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "",
      eventInfo: {
        container: "",
        media: "",
        title: "",
        subtitle: "",
        button: "",
        questions: "",
      },
      about: {
        container: "",
        header: "",
        text: "",
      },
      location: {
        container: "",
        header: "",
        text: "",
        map: "",
        mapPinColor: "",
        mapStrokeColor: "",
      },
      downloadWERZ: {
        container: "",
        header: "",
        text: "",
      },
      tickets: {
        header: "",
        outerContainer: "",
        innerContainer: "",
        ticket: {
          container: "",
          media: "",
          name: "",
          description: "",
          price: "",
          quantity: "",
          status: "",
          counterContainer: "",
          button: "",
          plusMinusColor: "",
        },
      },
    },
  },
}

export default clubCommission
